module.exports = __webpack_public_path__ + "static/media/5@3x.8819dc9b.png";